import { Route, Routes, BrowserRouter } from "react-router-dom";
import { AppProvider } from './AppContext';
import Header from './components/header';
import Travel from './components/travel';
import TravelCarousel from './components/travelcarousel';
import Producteurs from './components/producteurs';
import Adherents from './components/adherents';
import UserView from './components/userFiche';
import UserViewPW from './components/userFichePW';
import UserViewReinit from './components/userFicheReinit';
import UserViewUP from './components/userFicheUpdate';
import UserCreat from './components/userFicheCreat';
import Footer from './components/footer';
import Biasses from './components/biasses';
import BiasseFiche from './components/biasseFiche';
import Articles from './components/articles';
import JeCommande from './components/jecommande';
import LesCommandes from './components/lesCommandes';
import MonPanier from './components/monPanier';
import LesCommandesPro from './components/lesCommandesPro';
import LesCommandesTab from './components/lesCommandesTab';
import MesCommandes from './components/mesCommandes';
import MesCommandesTab from './components/mesCommandesTab';
import CGU from './components/cgu';
import MentionsLegales from './components/mentionsLegales';
import Politique from './components/politique';

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<TravelCarousel />} />
          <Route path="/travel" element={<TravelCarousel />} />
          <Route path="/travel/:postId" element={<TravelCarousel />} />
          <Route path="/userfiche" element={<UserView />} />
          <Route path="/userfiche/:postId" element={<UserView />} />
          <Route path="/userficheup" element={<UserViewUP />} />
          <Route path="/userficheup/:postId" element={<UserViewUP />} />
          <Route path="/userfichepw/:postId" element={<UserViewPW />} />
          <Route path="/userfichereinit" element={<UserViewReinit />} />
          <Route path="/userfichecreat" element={<UserCreat />} />
          <Route path="/producteurs" element={<Producteurs />} />
          <Route path="/adherents" element={<Adherents />} />
          <Route path="/biasses" element={<Biasses />} />
          <Route path="/biasses/:postId" element={<BiasseFiche />} />
          <Route path="/articles" element={<Articles />} />
          <Route path="/articles/:postId" element={<Articles />} />
          <Route path="/jecommande" element={<JeCommande />} />
          <Route path="/jecommande/:postId" element={<JeCommande />} />
          <Route path="/mescommandes" element={<MesCommandes />} />
          <Route path="/mescommandes/:postId" element={<MesCommandes />} />
          <Route path="/monPanier" element={<MonPanier />} />
          <Route path="/monPanier/:postId" element={<MonPanier />} />
          <Route path="/lescommandes" element={<LesCommandes />} />
          <Route path="/lescommandes/:postId" element={<LesCommandes />} />
          <Route path="/lescommandespro" element={<LesCommandesPro />} />
          <Route path="/lescommandespro/:postId" element={<LesCommandesPro />} />
          <Route path="/lescommandestab" element={<LesCommandesTab />} />
          <Route path="/lescommandestab/:postId" element={<LesCommandesTab />} />
          <Route path="/mescommandestab" element={<MesCommandesTab />} />
          <Route path="/mescommandestab/:postId" element={<MesCommandesTab />} />
          <Route path="/cgu" element={<CGU />} />
          <Route path="/mentionslegales" element={<MentionsLegales />} />
          <Route path="/politique" element={<Politique />} />
          <Route element={<Travel />} />
          <Route
            path="*"
            element={
              <main>
                <div className="main-down"></div>
                <section className="section-prods">
                  <p className="p-impact">Demande rejetée - Vous n'êtes pas autorisé à accéder à ces informations</p>
                </section>
              </main>
            }
          />
        </Routes>
        <Footer />
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
